import { Component, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from './../forms/input-control.base';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';

/** @deprecated Use `astral-input type="email"`; preserve this component only in unmigrated legacy templates. */
@Component({
    selector: 'app-email-box',
    templateUrl: './email-box.component.html',
    styleUrls: ['./email-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailBoxComponent extends InputControlBase {
  constructor(private _router: Router) {
    super();
  }

  private emailValidator(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.email(control);
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.control) {
      throw new Error('A control model must be specified.');
    }

    this.control.addValidators(this.emailValidator);
    this.control.updateValueAndValidity();
  }

  sendEmail() {
    if (!this.control.value) {
      return;
    }

    this._router.navigateByUrl('/dh/email/send-generic?tmpusr=' + encodeURIComponent(this.control.value));
  }
}
